export default {
  orderStatus: {
    0: "Vous avez soumis la commande, veuillez attendre que l'agent d'achat reçoive la commande",
    23: "L'agent d'achat a reçu la commande et est en contact avec le marchand",
    22: 'Vos marchandises ont été commandées, numéro de transaction : ',
    5: "Le marchand a expédié, méthode d'expédition : ",
    10: "Votre produit est arrivé à l'entrepôt désigné d'Acbuy",
    16: 'Votre demande de retour a été soumise. Veuillez patienter pendant que votre agent la traite',
    17: 'Votre demande de remplacement a été soumise. Veuillez patienter pendant que votre agent la traite',
    buyerReturn:
      'L’agent a soumis une demande de retour en raison des besoins du client, des risques liés à l’article, etc. Veuillez patienter pendant le traitement',
    buyerReplace:
      'L’agent a soumis une demande de remplacement en raison des besoins du client, des risques liés à l’article, etc. Veuillez patienter pendant le traitement',
    20: 'La commande a été retournée',
    beenReturned: ' Vérifier les remboursements >',
    30: 'Votre article a été expédié, consultez le colis pour savoir où il se trouve : ',
    43: 'Votre demande de retour est annulée',
    44: "Votre demande d'échange est annulée",
    49: "Prolongation de stockage non payée. L'article est considéré comme volontairement abandonné.",
  },
  expressNo: 'Numéro de suivi : ',
}
